import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=175f42e7"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style0 from "./Payments.vue?vue&type=style&index=0&id=175f42e7&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175f42e7')) {
      api.createRecord('175f42e7', component.options)
    } else {
      api.reload('175f42e7', component.options)
    }
    module.hot.accept("./Payments.vue?vue&type=template&id=175f42e7", function () {
      api.rerender('175f42e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payments.vue"
export default component.exports